import React from 'react';
import { IconProps } from './types';

export const NextAngle = ({ className, title }: IconProps) => (
  <svg
    id="Forward_Arrow_Icon"
    className={className}
    data-name="Forward Arrow Icon"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="13"
    viewBox="0 0 8 13"
  >
    <title>{title}</title>
    <g id="Back_Arrow_Icon" data-name="Back Arrow Icon">
      <path
        id="Fill_1"
        fill="currentColor"
        data-name="Fill 1"
        className="cls-1"
        d="M10.59,7,6,2.673,1.41,7,0,5.668,6,0l6,5.668Z"
        transform="translate(7.5 0.5) rotate(90)"
      />
    </g>
  </svg>
);
